export default Object.freeze({
  API_DOMAIN: process.env.API_DOMAIN,
  MICROSITE_DOMAIN: process.env.MICROSITE_DOMAIN
})